import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { baseVanillaSchema } from './shared/base-vanilla.schema';
import { contractTypeSchema } from './shared/contract-type.schema';
import { sideSchema } from './shared/side.schema';
export const vanillaSchema = baseVanillaSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.Vanilla),
    contract_type: contractTypeSchema,
    side: sideSchema,
});
